import { Context } from 'effect';
import { Url } from '../api';

export interface GluonConfigInterface {
    gluonUrl: Url.Url;
}

export class GluonConfig extends Context.Tag('@fixtuur/backpack/GluonConfig')<
    GluonConfig,
    GluonConfigInterface
>() {}
